//英文

export default {
  title:{
    homeTitle:'intelligentjoy'
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en.js